export const CURRENCY_SYMBOLS = {
    BGN: 'лв',
    CLP: 'CLP',
    CNY: '¥',
    COP: 'COP',
    CZK: 'Kč',
    DKK: 'kr.',
    EUR: '€',
    HUF: 'Ft',
    IDR: 'Rp',
    INR: '₹',
    JPY: '¥',
    KRW: '₩',
    KZT: '₸',
    MXN: 'MXN',
    MYR: 'RM',
    NOK: 'kr',
    PEN: 'S/.',
    PLN: 'zł',
    RON: 'lei',
    RSD: 'РСД',
    SEK: 'kr',
    THB: '฿',
    UAH: '₴',
    USD: '$',
    ARS: 'ARS',
    BZD: 'BZ$',
    CRC: '₡',
    UYU: 'UYU',
    GTQ: 'Q',
    HNL: 'L',
    NIO: 'C$',
    DOP: 'RD$',
    BOB: 'Bs.',
    PYG: '₲',
    PAB: 'B/.'
};

export const CURRENCIES_TO_HIDE_CENTS = ['ARS', 'COP', 'GTQ', 'CLP', 'MXN'];
